import { configureStore } from "@reduxjs/toolkit";
import sliderReducer from "../redux/slice/slider";
import testimonialReducer from "../redux/slice/testimonial";
import newsReducer from "../redux/slice/news";
import categoryReducer from "../redux/slice/category";
import productReducer from "../redux/slice/product";
import sentRfqReducer from "./slice/sentRfq";
import receivedRfqReducer from "./slice/receivedRfq";
import cashWalletReducer from "./slice/cashWallet";
import creditWalletReducer from "./slice/creditWallet";
import addressReducer from "./slice/address";
import sentOrderReducer from "./slice/sentOrder";
import receivedOrderReducer from "./slice/receivedOrder";
import commodityProductReducer from "./slice/commodityProduct";
import transporterProductReducer from "./slice/transporterProduct";
import transporterOrderReducer from "./slice/transporterOrder";
import webSetupReducer from "./slice/webSetup";
import howToReducer from "./slice/howTo";
import brandReducer from "./slice/brand";
import businessCategoryProductReducer from "./slice/businessCategoryProduct";
import businessCategoryReducer from "./slice/businessCategory";

export const store = configureStore({
  reducer: {
    slider: sliderReducer,
    testimonial: testimonialReducer,
    news: newsReducer,
    category: categoryReducer,
    product: productReducer,
    sentRfq: sentRfqReducer,
    receivedRfq: receivedRfqReducer,
    cashWallet: cashWalletReducer,
    creditWallet: creditWalletReducer,
    address: addressReducer,
    sentOrder: sentOrderReducer,
    receivedOrder: receivedOrderReducer,
    commodityProduct: commodityProductReducer,
    transporterProduct: transporterProductReducer,
    transporterOrder: transporterOrderReducer,
    webSetup: webSetupReducer,
    howTo: howToReducer,
    brand: brandReducer,
    businessCategoryProduct: businessCategoryProductReducer,
    businessCategory: businessCategoryReducer,
  },
});

export default store;
